import { render, staticRenderFns } from "./EventoLista.vue?vue&type=template&id=78a2b5b2&"
import script from "./EventoLista.vue?vue&type=script&lang=js&"
export * from "./EventoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports